module.exports = __webpack_public_path__ + "static/media/fe-based-error.30ecb86d.png";